import { createContext, useContext, type ReactNode } from 'react';
import { PORTALS, type PortalConfig } from '../model/portals';

// Screens with no provider stay in the admin portal.
const PortalScopeContext = createContext<PortalConfig<string>>(PORTALS.admin);

/** Tells the shared screens below which portal they serve. */
export function PortalScope({
  portal,
  children,
}: {
  portal: PortalConfig<string>;
  children: ReactNode;
}) {
  return <PortalScopeContext.Provider value={portal}>{children}</PortalScopeContext.Provider>;
}

export function usePortalScope(): PortalConfig<string> {
  return useContext(PortalScopeContext);
}
